// extracted by mini-css-extract-plugin
export var radioInputRow = "B_s0";
export var radioInputColumn = "B_s1";
export var inputOptionRow = "B_qk";
export var inputOptionColumn = "B_ql";